module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/ABOUT_02-mission.png";